<template>
    <div v-loading="loadFull">
        <el-form ref="formDom" :model="form" :rules="rules" label-position="left" label-width="120px" class="form-wrap" :disabled="!isCurrent || type === 'preview'">
            <el-form-item label="预计开发周期" prop="estimatedDuration">
                <el-input v-model="form.estimatedDuration" placeholder="请输入" maxlength="50" show-word-limit />
            </el-form-item>
            <el-form-item label="开始日期" prop="startDate">
                <el-date-picker v-model="form.startDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="截止日期" prop="endDate">
                <el-date-picker v-model="form.endDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="开发人员" prop="developUser">
                <el-input v-model="form.developUser" placeholder="请输入" maxlength="100" show-word-limit />
            </el-form-item>
            <el-form-item label="上线日期" prop="releaseDate">
                <el-date-picker v-model="form.releaseDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="详细内容">
                <el-input v-model="form.detail" type="textarea" placeholder="请输入" maxlength="1000" show-word-limit :autosize="{ minRows: 2, maxRows: 6}" />
            </el-form-item>
        </el-form>
        <!-- 底部按钮 -->
        <div class="footer-operation" v-if="type != 'preview' && isCurrent">
            <el-button @click="onRollback">上一步</el-button>
            <el-button type="primary" :loading="loadSubmit" @click="onSubmit">完成</el-button>
            <el-button type="primary" plain :loading="loadSave" @click="onSave">暂存</el-button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { findRequirementDevelop, addRequirementDevelop, updateRequirementDevelop } from '@/api/requirement'

export default {
    props: {
        requirementId: [Number, String],
        currentStep: [Number, String],
        // 弹窗类型：add 新增 | edit 编辑 | preview 预览
        type: String,
    },
    data() {
        return {
            loadFull: false,
            form: {
                id: '',
                requirementId: this.requirementId,
                estimatedDuration: '',
                startDate: '',
                endDate: '',
                developUser: '',
                releaseDate: '',
                detail: '',
            },
            rules: {
                estimatedDuration: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                startDate: [
                    { required: true, message: '请选择', trigger: 'blur' }
                ],
                endDate: [
                    { required: true, message: '请选择', trigger: 'blur' }
                ],
                developUser: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                releaseDate: [
                    { required: true, message: '请选择', trigger: 'blur' }
                ],
            },
            loadSave: false,
            loadSubmit: false,
        }
    },
    computed: {
        ...mapState(["productList", "schoolList", "salePersonOption"]),
        // 进度是否为当前节点
        isCurrent() {
            return this.currentStep === 3 ? true : false
        }
    },
    methods: {
        // 提交表单
        onSubmit() {
            this.loadSubmit = true;
            this.$refs.formDom.validate(valid => {
                if (valid) {
                    let reqApi = addRequirementDevelop;
                    if (this.form.id) {
                        reqApi = updateRequirementDevelop;
                    }
                    reqApi(this.form).then(() => {
                        this.loadSubmit = false;
                        this.$emit('push');
                    }).catch(err => {
                        this.loadSubmit = false;
                        this.$MessageBox.MessageWarning(err.data.msg);
                    })
                } else {
                    this.loadSubmit = false;
                    return;
                }
            })
        },
        // 清空表单校验
        clearForm() {
            this.$refs.formDom.resetFields();
        },
        // 回显表单信息
        echoInfo() {
            if (!this.requirementId) return;
            this.form.requirementId = this.requirementId;
            this.loadFull = true;
            this.$refs.formDom.resetFields();
            findRequirementDevelop({ requirementId: this.requirementId }).then(res => {
                if (res.data) {
                    this.form = { ...res.data }
                } else {
                    this.form.id = null;
                    this.clearForm();
                }
                this.loadFull = false;
            }).catch(err => {
                this.loadFull = false;
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        },
        // 点击“上一步” 回退步骤
        onRollback() {
            this.$emit('rollback');
        },
        // 点击“保存”
        onSave() {
            this.loadSave = true;
            let reqApi = addRequirementDevelop;
            if (this.form.id) {
                reqApi = updateRequirementDevelop;
            }
            reqApi(this.form).then(res => {
                this.form.id = res.data;
                this.loadSave = false;
                this.$MessageBox.MessageSuccess(res.msg);
            }).catch(err => {
                this.loadSave = false;
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.form-wrap {
    width: 600px;
    margin: 0 auto;
    /deep/ .el-form-item {
        .el-form-item__label {
            font-size: 1rem;
        }
        .el-form-item__content {
            > .el-input,
            .el-select,
            .el-textarea {
                width: 100%;
            }
        }
    }
}
.connect-box {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-left: 15px;
    color: #0540c3;
    vertical-align: -3px;
    cursor: pointer;
    img {
        width: 18px;
    }
}
/deep/ .el-textarea {
    .el-textarea__inner {
        padding-bottom: 20px;
    }
    .el-input__count {
        height: 20px;
        line-height: 20px;
        left: 15px;
        text-align: right;
        bottom: 1px;
        right: 25px;
    }
}
.footer-operation {
    display: flex;
    justify-content: center;
    > .el-button {
        height: 32px;
        line-height: 31px;
        padding-top: 0;
        padding-bottom: 0;
    }
}
</style>